import { IThreeDCategoryAutocompleteListItem } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

async function getThreeDCategoryAutocomplete(
  searchKeyword: string | null
): Promise<AxiosResponse<FetchResult<IThreeDCategoryAutocompleteListItem[]>>> {
  const response = await instance.get(`/assets-3d/categories/autocomplete?searchKeyword=${searchKeyword}`);
  return response;
}

const useFetchThreeDCategoryAutocomplete = (searchKeyword: string | null) => {
  const { data: originalData, error } = useQuery({
    queryKey: ['get', `/assets-3d/categories/autocomplete?searchKeyword=${searchKeyword}`],
    queryFn: () => getThreeDCategoryAutocomplete(searchKeyword),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(searchKeyword)
  });

  const data = originalData?.data.data;

  return { data, error };
};

export default useFetchThreeDCategoryAutocomplete;
